import { AggregationInterval } from 'mapistry-shared';

export const aggregationIntervalsInGrowingOrder = [
  AggregationInterval.HOUR,
  AggregationInterval.DAY,
  AggregationInterval.WEEK,
  AggregationInterval.MONTH,
  AggregationInterval.QUARTER,
  AggregationInterval.YEAR,
];

export const aggregationIntervalLabels: {
  [key in AggregationInterval]: string;
} = {
  [AggregationInterval.HOUR]: 'Hours',
  [AggregationInterval.DAY]: 'Days',
  [AggregationInterval.WEEK]: 'Weeks',
  [AggregationInterval.MONTH]: 'Months',
  [AggregationInterval.QUARTER]: 'Quarters',
  [AggregationInterval.SEMI_ANNUAL]: 'Semi-Annual',
  [AggregationInterval.YEAR]: 'Years',
};
